import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import filter from "../assets/images/filter-icon.svg";
import backArrow from "../assets/images/arrow_icon.png";
import ObjectionResponse from "./ObjectionResponse";

const Objections = ({ backhandler }) => {
  const [fileData, setFileData] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [data, setData] = useState({ objection: "", prompts: "" });

  useEffect(() => {
    const readExcelFile = async () => {
      try {
        // Fetch the Excel file from the public folder
        const response = await fetch("/Objection.xlsx");
        const arrayBuffer = await response.arrayBuffer();

        const workbook = XLSX.read(arrayBuffer, { type: "buffer" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const filteredData = jsonData.map((row) => ({
          Objection: row.Objection,
          Prompt: row["Prompt for AI lightning bolt"],
        }));

        setFileData(filteredData);
      } catch (err) {
        console.error("Error while reading the Excel file:", err);
      }
    };

    readExcelFile();
  }, []);

  const backToObjection = () => {
    setIsClicked(false);
  };
  const handleNavigate = (obj, prompt) => {
    setIsClicked(true);
    setData({ objection: obj, prompts: prompt });
  };
  if (isClicked) {
    return <ObjectionResponse data={data} backhandler={backToObjection} />;
  }
  return (
    <>
      {!isClicked && (
        <div className="container cl-main-container">
          <div className="card p-3 bg-transparent cl-main-card">
            <div className="card cl-secondary-card">
              <div className="card-body p-4">
                <div className="cl-filter-icon">
                  <label>
                    <span>
                      <img className="img-fluid" src={filter} alt="Filter" />
                    </span>
                    Conversion Lab
                  </label>
                  <hr className="cl-heading-border" />
                </div>
                <div className="form-floating mt-3">
                  <div className="p-4 text-center cl-internal-area-container">
                    <div id="cl-floating-textarea">
                      {fileData
                        ? fileData.length > 0 &&
                          fileData.map((item, index) => {
                            return (
                              <button
                                key={index}
                                type="button"
                                className="btn rounded-pill btn-outline-primary mt-3 mx-auto cl-objection-btn"
                                onClick={() =>
                                  handleNavigate(item.Objection, item.Prompt)
                                }
                              >
                                {item.Objection}
                              </button>
                            );
                          })
                        : "Loading..."}
                    </div>
                  </div>
                </div>
                <div className="mt-2">
                  <button
                    type="button"
                    className="btn cl-goback-btn"
                    onClick={backhandler}
                  >
                    <span className="me-1 align-items-center">
                      <img
                        className="img-fluid"
                        src={backArrow}
                        alt="Go Back"
                      />
                    </span>{" "}
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Objections;
